import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const CheckoutCoupon = ({
  onCampaignCodeChange,
  onSubmitCampaignCode,
  errors,
}) => (
  <Fragment>
    <div className="checkout-info__campaign-code">
      <div className="justify-center">
        <input
          className="form__input"
          id="campaign-code"
          placeholder={translate('checkout.campaigncode')}
          onChange={(event) => onCampaignCodeChange(event.target.value)}
        />
        <button
          className="checkout-info__campaign-button button"
          onClick={() => onSubmitCampaignCode()}
        >
          {translate('checkout.usecampaigncode')}
        </button>
      </div>
    </div>
    {errors && errors['campaignCode'] && (
      <span
        className="form__validator--error form__validator--top-narrow"
        data-error-for="campaign-code"
      >
        {errors['campaignCode'][0]}
      </span>
    )}
  </Fragment>
);

export default CheckoutCoupon;
